import { toast } from 'react-toastify';
import Cookie from 'universal-cookie';
const cookie = new Cookie();



export const checkAuth = (statusCode) => {
  switch (statusCode) {
    case 401: // Unauthorized
      cookie.remove('authToken', { path: '/' });
      cookie.remove('user', { path: '/' });
      cookie.remove('userId', { path: '/' });
      toast.error('Your session has expired. Please login again.');
      window.location.href = '/auth/sign-in';
      break;
    case 403: // Forbidden
      toast.error('You do not have permission to access this resource.');
      // Optionally, redirect to a different page
      break;
    case 404: // Not Found
      toast.error('The requested resource was not found.');
      // Optionally, redirect to a 404 error page
      break;
    case 500: // Internal Server Error
      toast.error('An internal server error occurred. Please try again later.');
      // Optionally, log the error or notify the development team
      break;
    case 503: // Service Unavailable
      toast.error('The service is currently unavailable. Please try again later.');
      // Optionally, implement retry logic or notify the user of maintenance
      break;
    default: // Other HTTP errors
      toast.error(`An error occurred: ${statusCode}`);
      // Optionally, handle other status codes or log the error
      break;
  }
};
